import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { NavController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { AuthRedirectService } from '../auth/auth-redirect.service';

@Injectable({
	providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
	constructor(
		private navCtrl: NavController,
		private authService: AuthService,
		private authRedirectService: AuthRedirectService
	) {}

	/**
	 * Wait for auth initialization to complete before checking token state.
	 * This prevents race conditions where the guard runs before tokens are restored from storage.
	 */
	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return this.authService.authReady$.pipe(
			take(1),
			map(() => {
				if (!this.authService.token?.access) {
					this.authRedirectService.setRedirectUrl(state.url);
					this.navCtrl.navigateForward('/login');
					return false;
				}
				return true;
			})
		);
	}
}
